import { appUI } from 'lib/app-ui';
import { nui } from 'lib/nodes-ui';
import CopyPaste from 'lib/copy-paste';
import { dragdrop } from 'lib/drag-drop';

class NodeDragUI {

  constructor() {
  }

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  setDragSubjects({ nodeIds=[] }) {
    for (const id of nodeIds) {
      const nodeTag = this.canvas.getNodeTag({ id });
      if (nodeTag.refs.container) {
        // nodeTag.refs.container.classList.add('no-pointer-events');
        nodeTag.refs.container.classList.add('drag-subject');
      }
      nodeTag.isDraggingSubject = true;
      if (nodeTag.refs.expandTool) {
        nodeTag.refs.expandTool.style.pointerEvents = 'none';
      }
    }
  }

  unsetDragSubjects({ nodeIds=[] }) {
    for (const id of nodeIds) {
      const nodeTag = this.canvas.getNodeTag({ id });
      if (nodeTag.refs.container) {
        // nodeTag.refs.container.classList.remove('no-pointer-events');
        nodeTag.refs.container.classList.remove('drag-subject');
      }
      nodeTag.isDraggingSubject = false;
      if (nodeTag.refs.expandTool) {
        nodeTag.refs.expandTool.style.pointerEvents = 'all';
      }
    }
  }

  /*
    called from node-drag-handlers
  */
  handleFreehandAdoption({ adopt, newParent, dragNodeTag, dragInstance }) {
    const children = newParent.children();
    const newParentId = newParent.id;
    let newOrderIndex = 0;
    if (children && children.length) {
      newOrderIndex = children[children.length - 1].orderIndex + 1;
    }

    const { scale, tx, ty } = this.canvas.getMatrix();
    let parentRect;
    if (this.canvas.nodeTags[newParentId].childNodesTag
      && this.canvas.nodeTags[newParentId].childNodesTag.refs.childNodes) {
      parentRect = this.canvas.nodeTags[newParentId].childNodesTag.refs.childNodes.getBoundingClientRect();
    } else {
      parentRect = this.canvas.nodeTags[newParentId].refs.colGroupContainer.getBoundingClientRect();
    }

    const parentOffset = appUI.viewportCoordsToMapCoords(parentRect);
    const topLevelNodes = this.canvas.getRootSelectedNodes();
    if (topLevelNodes.length > 1) {
      //multiple adoption at the same time
      const newnodeTag = this.canvas.nodeTags[dragNodeTag.id];
      let parentAdj = { x: 0, y: 0 };
      if (dragNodeTag.parentId && store.getNode(dragNodeTag.parentId).getLayoutName() === 'layout-freehand') {
        const parentNodePos = store.getNode(dragNodeTag.parentId).absolutePosition;
        const containerOffset = $(this.canvas.nodeTags[dragNodeTag.parentId].refs.container).offset();
        let childNodesOffset = $(this.canvas.nodeTags[dragNodeTag.parentId].childNodesTag.refs.childNodes).offset();
        if (!childNodesOffset) {
          childNodesOffset = $(this.canvas.nodeTags[dragNodeTag.parentId].refs.colGroupContainer).offset();
        }
        parentAdj = {
          x: parentNodePos.x + (childNodesOffset.left - containerOffset.left) / scale,
          y: parentNodePos.y + (childNodesOffset.top - containerOffset.top) / scale
        };
      }


      for (const node of topLevelNodes) {
        node.x = node.absolutePosition.x;
        node.y = node.absolutePosition.y;
      }
      CopyPaste.normalizeNodePositions({
        nodes: topLevelNodes,
      });

      const minX = Math.min.apply(null,topLevelNodes.map(n => n.absolutePosition.x));
      const minY = Math.min.apply(null,topLevelNodes.map(n => n.absolutePosition.y));

      let yDiff = 0;
      let xDiff = 0;
      if (parentOffset.y < minY) {
        yDiff = minY - parentOffset.y;
      }
      if (parentOffset.x < minX) {
        xDiff = minX - parentOffset.x;
      }
      topLevelNodes.forEach(selectedElement => {
        let newYPos = selectedElement.y + yDiff;
        let newXPos = selectedElement.x + xDiff;
        adopt(selectedElement, newParentId, { x: newXPos, y: newYPos }, newOrderIndex);
        this.canvas.nodeTags[selectedElement.id].update();
      });
    } else {

      let newXPos;
      let newYPos;

      if (newParent.getChildrenDetached() && newParent.getIsCollapsed()) {
        /* if putting cards into a collapsed freehand, disperse them a little so they're not all on top of each other */
        newYPos = Math.floor((Math.random() * 50));
        newXPos = Math.floor((Math.random() * 50));
      } else {
        newXPos = dragInstance.absolutePosition.x - parentOffset.x;
        newYPos = dragInstance.absolutePosition.y - parentOffset.y;
        if (newYPos < 0) newYPos = 0;
        if (newXPos < 0) newXPos = 0;
      }
      adopt(dragInstance, newParentId, { x: newXPos, y: newYPos }, newOrderIndex);
    }
    if (this.canvas.nodeTags[newParentId].childNodesTag) {
      this.canvas.nodeTags[newParentId].childNodesTag.fitToContents();
    }
  }

  handleBulkEmancipateFromFreehand({ topSelectedElements, selectedNodes, childNodesRect, dragNodeTag }) {
    /*
      if all parts are outside the parent, then emancipate
    */
    let emancipateAll = true;
    for (const nodeTag of topSelectedElements) {
      if (!(childNodesRect && childNodesRect.left)) continue;
      const dragPosition = nodeTag.instance.absolutePosition;
      const node = nodeTag.instance;
      const emancipatingFreehandChild =
         dragPosition.x + node.width * 0.8 < childNodesRect.left
         || dragPosition.x + node.width * 0.2 > childNodesRect.right
         || dragPosition.y + node.height * 1 < childNodesRect.top
         || dragPosition.y + node.height * 0.0 > childNodesRect.bottom;

      if (!emancipatingFreehandChild) {
        emancipateAll = false;
        break;
      }
    }

    if (emancipateAll) {
      /* we've dragged a bulk selection of cards outside a freehand container */
      topSelectedElements.forEach(element => {
        const selectedNode = this.canvas.store.getNode(element.id);
        if (selectedNode.parentId && !selectedNodes.includes(selectedNode.parentId)) {
          selectedNodes.push(selectedNode.parentId);
        }

        let newLocation;
        if (selectedNode.getTopLevelParent().link()) {
          newLocation = element.getRenderedPosition();
        } else {
          newLocation = {
            x: selectedNode.absolutePosition.x,
            y: selectedNode.absolutePosition.y
          };
        }

        element.formerParentId = selectedNode.parentId;
        selectedNode.emancipateSelf(newLocation);
        element.child = false;
      });
      dragNodeTag.emancipating = true;
      this.canvas.emancipationTriggered = true;

      // loop through one last time and do the updates
      this.canvas.nodesTag.update();

      topSelectedElements.forEach(element => {
        element.update({ forceUpdate: true });
        element.updateTopLevelNeighborsLite();
      });

      const nodeIds = topSelectedElements.map(n => n.id);
      dragdrop.calculateTargetRects(nodeIds);
      this.setDragSubjects({ nodeIds });
    }

    return {
      emancipatedAll: emancipateAll
    };
  }

}

// singleton instance
const ndui = new NodeDragUI();

export { NodeDragUI, ndui };



// WEBPACK FOOTER //
// ./starling/src/lib/node-drag-ui.js